// BUG-2026-395890：普通商品「显示商城」与「支持的支付方式」联动。
// 对应关系与 App 后端 GoodsMallPolicy.allows 一致：商品要在某个商城可买，
// 必须同时勾了该商城、并勾了该商城对应的支付方式。两边口径改一处必须改另一处。
export const MALL_AREA_OPTIONS = [
  { id: 3, name: '现金余额支付区', payModes: ['CASH', 'BALANCE'] },
  { id: 4, name: '零售价兑换专区', payModes: ['XIAODUBI'] },
  { id: 5, name: '学费赠送专区', payModes: ['GIFT'] }
]

const AREA_BY_ID = MALL_AREA_OPTIONS.reduce((map, item) => { map[item.id] = item; return map }, {})

function areaId(item) {
  return Number(item && typeof item === 'object' ? item.id : item)
}

/** 选中的商城允许勾选的支付方式（并集）；没选商城时为空 */
export function allowedPayModes(areas) {
  const set = {}
  ;(areas || []).forEach(item => {
    const area = AREA_BY_ID[areaId(item)]
    if (area) area.payModes.forEach(mode => { set[mode] = true })
  })
  return Object.keys(set)
}

/** 勾了商城却没勾它对应的任何支付方式 —— 这类商品在 App 该商城里不显示 */
export function areasMissingPayMode(areas, payModes) {
  const chosen = payModes || []
  return (areas || []).map(item => AREA_BY_ID[areaId(item)])
    .filter(area => area && !area.payModes.some(mode => chosen.indexOf(mode) > -1))
}

/** 列表、详情显示用：按编码给新名称，非普通商城（秒杀/积分）沿用库里的名字 */
export function mallAreaName(item) {
  const area = AREA_BY_ID[areaId(item)]
  return area ? area.name : (item && item.name) || ''
}
